export default __webpack_public_path__ + "static/media/ThreeStrands-band.6c9b55d7.svg";